
const moment = require('moment-timezone');

export function empty(data)
{
  if(typeof(data) === 'number' || typeof(data) === 'boolean')
  { 
    return false; 
  }
  if(typeof(data) === 'undefined' || data === null)
  {
    return true; 
  }
  if(typeof(data.length) !== 'undefined')
  {
    return data.length === 0;
  }
  var count = 0;
  for(var i in data)
  {
    if(data.hasOwnProperty(i))
    {
      count ++;
    }
  }
  return count === 0;
}

//verifica data-hora inserida respeita tempos de arranque quer seja G ou B
export function dateBelowNow(myDate, myTime, TA, TAB, TC, TCB, TS, TSB, retro, numFP, numG, numGT, numC, numB, numBT, numCB, numGG, numBG, numParados, operType) {

    if (!myDate || !myTime) {
        return false;
    }
    let myDatetime = moment(myDate + " " + myTime, 'YYYY-MM-DD HH:mm', true);//data-hora inserido
    let myDatetimePlus1Day = moment().tz("Europe/Lisbon").add(1,'day');//hoje mais um dia
    if (!myDatetime.isValid()) {
        return false;
    }
    let myStartDate;
    let numActivosG = Number(numG) + Number(numGT) + Number(numGG);// + Number(numC);//geração
    let numActivosB = Number(numB) + Number(numBT) + Number(numBG);// + Number(numCB);//bombagem
    let MS_PER_MINUTE = 60000;//1 minuto, em milisegundos
    let now = moment().tz("Europe/Lisbon");
               
    //verificar se o numero de grupos ativos aumentou, se sim, temos de validar tempo de arranque. Se não, n é necessário, apenas tempo de tomada de carga
    //1 minuto adicionados, tempo de operador processar
    if(Number(numFP) < Number(numParados)){//entradas
        //geração
        if(numActivosG > 0){
            // myStartDate = now + ((TA + TC + 0.5) * MS_PER_MINUTE);
            myStartDate = now + ((TA + TC) * MS_PER_MINUTE);
        }else if(numActivosB > 0){//bombagem
            myStartDate = now + ((TAB + TCB) * MS_PER_MINUTE);
        }else if(numC > 0){//compensador gerador
            myStartDate = now + ((TA + TC) * MS_PER_MINUTE);            
        }else if(numCB > 0){//compensador bombagem
            myStartDate = now + ((TAB + TCB) * MS_PER_MINUTE);
        }
        else{//FP
            myStartDate = now;
        }
    }else if(Number(numFP) > Number(numParados)){//saídas
        //geração
        if(numActivosG > 0 || operType === 'G'){
            myStartDate = now + ((TS) * MS_PER_MINUTE);
        }else if(numActivosB > 0 || operType === 'B'){//bombagem
            myStartDate = now + ((TSB) * MS_PER_MINUTE);
        }else{//FP
            myStartDate = now;
        }
    }else{//variação (num de grupos é o mesmo, mas podem passar de G para B, e vice versa)
        //console.log('variação + operType: ' + operType);
        //geração
        if(numActivosG > 0){
            if(operType === 'B'){
                //grupo antes estava em modo Bomba, logo temos de adicionar o tempo todo
                myStartDate = now + ((TA + TC) * MS_PER_MINUTE);
            }else{
                //variação normal, grupo já estava em Geração
                myStartDate = now + ((TC) * MS_PER_MINUTE);
            }
        }else if(numActivosB > 0){//bombagem
            if(operType === 'G'){
                //grupo antes estava em modo Geração, logo temos de adicionar o tempo todo
                myStartDate = now + ((TAB + TCB) * MS_PER_MINUTE);
            }else{
                //variação normal, grupo já estava em Bomba
                myStartDate = now + ((TCB) * MS_PER_MINUTE);
            }
        }else{//FP
            myStartDate = now;
        }
    }
    if(retro > 0){//retira validações caso seja ID retroativa, apenas tem de ser passado    
        if ( myDatetime > myStartDate) {
            return false;
        }
    }
    else{
        //validamos data/hora possível e também se não fica demasiado para a frente, para prevenir enganos dos operadores
        if ( myDatetime < myStartDate || myDatetime > myDatetimePlus1Day) {
            return false;
        }
    }
    return true;
};

//devolve data-hora miníma possível para enviar nova ID - NOT USED!!!!
/*export function newPossibleDateTime(TA, TAB, TC, TCB, TS, TSB, numFP, numG, numGT, numC, numB, numBT, numCB, numParados) {

    let myStartDate;
    let numActivosG = Number(numG) + Number(numGT) + Number(numC);//geração
    let numActivosB = Number(numB) + Number(numBT) + Number(numCB);//bombagem
    let MS_PER_MINUTE = 60000;//1 minuto, em milisegundos
    let now = moment().tz("Europe/Lisbon");
         
    //verificar se o numero de grupos ativos aumentou, se sim, temos de validar tempo de arranque. Se não, n é necessário, apenas tempo de tomada de carga
    //1 minuto adicionados, tempo de operador processar
    if(Number(numFP) < Number(numParados)){//entradas
        //geração
        if(numActivosG > 0){
            myStartDate = now + ((TA + TC + 0.5) * MS_PER_MINUTE);
        }else if(numActivosB > 0){//bombagem
            myStartDate = now + ((TAB + TCB + 0.5) * MS_PER_MINUTE);
        }else{//FP
            myStartDate = now + (0.5 * MS_PER_MINUTE);
        }
    }else if(Number(numFP) > Number(numParados)){//saídas
        //geração
        if(numActivosG > 0){
            myStartDate = now + ((TS + 0.5) * MS_PER_MINUTE);
        }else if(numActivosB > 0){//bombagem
            myStartDate = now + ((TSB + 0.5) * MS_PER_MINUTE);
        }else{//FP
            myStartDate = now + (0.5 * MS_PER_MINUTE);
        }
    }else{//variação
        //geração
        if(numActivosG > 0){
            myStartDate = now + ((TC + 0.5) * MS_PER_MINUTE);
        }else if(numActivosB > 0){//bombagem
            myStartDate = now + ((TCB + 0.5) * MS_PER_MINUTE);
        }else{//FP
            myStartDate = now + (0.5 * MS_PER_MINUTE);
        }
    }

    return myStartDate;

};
*/

//verifica se potencia respeita maximos e minimo tecnicos consoante seja G ou B
export function powerAllowed(value, maxPow, minTec, maxPowB, minTecB, totalNum, numFP, numG, numB) {

    //geracao
	let maxPowerPerGroup = (Number(maxPow) / Number(totalNum)).toFixed(2);
	let minPowerPerGroup = (Number(minTec) / Number(totalNum)).toFixed(2);
    let numActivosG = Number(numG);
    //bombagem
    let maxPowerPerGroupB = (Number(maxPowB) / Number(totalNum)).toFixed(2);
	let minPowerPerGroupB = (Number(minTecB) / Number(totalNum)).toFixed(2);
    let numActivosB = Number(numB);
    

    if (empty(value)) {
        return false;
    } 
    else if (isNaN(Number(value))) {
        return false;     
    }
    else if(numActivosG > 0){//limite maximo geracao
        if (Number(value) > Number(maxPow)) {
            return false;
        }
        //verifica que potencia geracao respeita tendo em conta o numero de grupos ativos
        else if (Number(value) < (minPowerPerGroup * numActivosG).toFixed(1) || Number(value) > (maxPowerPerGroup * numActivosG).toFixed(1)) {
            return false;
        }
    }else if(numActivosB > 0){//limite maximo bombagem
        if (Number(value) < Number(maxPowB)) {
            return false;
        }
        //verifica que potencia geracao respeita tendo em conta o numero de grupos ativos
        else if (Number(value) > (minPowerPerGroupB * numActivosB).toFixed(1) || Number(value) < (maxPowerPerGroupB * numActivosB).toFixed(1)) {
            return false;
        }
    }else if(Number(totalNum) === Number(numFP)){ //se está tudo parado fica a 0
        if(Number(value)!== 0){
            return false;
        }
    }

    return true;
}

//verifica se potencia reativa tem valor ou nao caso haja grupos neste modo
export function powerReactAllowed(value, numCG, numCB, numG, numB, numGT, numBT, numGG, numBG, uf) {

    //lista de excepções para centrais que a energia reativa conta
    const exceptions = ['CAV', 'CAV2'];
    console.log(uf);
    console.log(exceptions.includes(uf));
    //tem de ter algum valor se existirem grupos em CG ou CB
    if ((isNaN(Number(value)) || empty(value)) && (Number(numCG) + Number(numCB) > 0)) {
        return false;     
    }
    //tem de ser vazio caso não existam grupos em CG, CB, G ou B
    //tbm n pode permitir centrais com contratos de Energia Reativa (CAV e CAV2)
    else if(exceptions.includes(uf)){
        if(!empty(value) && (Number(numCG) + Number(numCB) === 0)){
            return false;
        }
    }else{
        //+ Number(numGT) + Number(numBT) + Number(numGG) + Number(numBG) - para permitir reativa em modos TR
        if (!empty(value) && (Number(numCG) + Number(numCB) + Number(numG) + Number(numB) === 0)) { 
            return false;
        }
    }

    return true;
}

//verifica que numero de grupos não ultrapassa o total
export function totalGroupNum(value, totalNum, numFP, numG, numGT, numC, numB, numBT, numCB, numGG, numBG, workType, trType) {

    if (!value || empty(value)) {
        return false;
    } 
    else if (isNaN(Number(value))) {
        return false;    
    }
	
    let numActivos = Number(value) + Number(numFP) + Number(numG) + Number(numGT) + Number(numC) + Number(numB) + Number(numBT) + Number(numCB) + Number(numGG) + Number(numBG);
    let numGer;
    let numBomb;
    let numTRREN;
    let numTRGEM;

    if(workType === "G"){//validar campos de Geracao, value entra na Geracao
        numGer = Number(value) + Number(numG) + Number(numGT) + Number(numGG);
        numBomb = Number(numB) + Number(numBT) + Number(numBG);
    }else if(workType === "B"){//validar campos de Bombagem, value entra na Bombagem
        numGer = Number(numG) + Number(numGT) + Number(numGG);
        numBomb = Number(value) + Number(numB) + Number(numBT) + Number(numBG);
    }else{//validar campo FP, value nao entra em nenhum
        numGer = Number(numG) + Number(numGT) + Number(numGG);
        numBomb = Number(numB) + Number(numBT) + Number(numBG);
    }

    if(trType === "REN"){
        numTRREN = Number(value) + Number(numGT) + Number(numBT);
        numTRGEM = Number(numGG) + Number(numBG);
    }else if(trType === "GEM"){
        numTRREN = Number(numGT) + Number(numBT);
        numTRGEM = Number(value) + Number(numGG) + Number(numBG);
    }else{
        numTRREN = Number(numGT) + Number(numBT);
        numTRGEM = Number(numGG) + Number(numBG);
    }

    if (Number(value) < 0 || Number(value) > 999) {
        return false;
    }
    else if (numActivos !== totalNum) {//num de grupos diferente do numero de grupos da centraL
        return false;
    }
    else if (numGer >0 && numBomb > 0) { //geracao e bombagem simultaneamente, impossivel
        return false;
    }
    else if (numTRREN >0 && numTRGEM > 0) { //TRREN e TRGEM simultaneamente, impossivel
        return false;
    }

    return true;
}

export function reduceCellErrors(items, cells) {
    
    let res = false;

    cells.forEach((row, index) => {
        if (items[index].TO_SEND) {
            row.forEach(col => {
                if (col) {
                    res = true;
                    return;
                }
            });
        }
    });

    return res;
};

//verifica potencia respeita maximos e minimo tecnicos consoante seja G ou B
export function powerAllowedTerm(value, maxPow, minTec, state) {

    if (empty(value)) {
        return false;
    } 
    else if (isNaN(Number(value))) {
        return false;     
    }
    else if(state === 'FP' || state === 'IND'){
        if (Number(value) !== 0) {
            return false;
        }
    }else{
        if (Number(value) > Number(maxPow)) {
            return false;
        }
        //verifica que potencia geracao respeita tendo em conta o numero de grupos ativos
        //comentado para já porque temos IDs em energia e não em potência
        /*else if (Number(value) < Number(minTec)) {
            return false;
        }*/
    }
    return true;
}

//verifica valores nas rows a importar do ficheiro excel
export function verifyRowData(rows, units, loggedUser) {

    console.dir(rows);
    console.dir(units);
    //validar datas
    let timezone = loggedUser.profile.TIMEZONE;
    let auxNumRows = rows.length;
    let auxText = '';
    let newItem = {};
    let arrayMain = [];
    let auxLengthRaw = 0;
    let auxLengthTrim = 0;

    for (let i = 0; i < auxNumRows; i++) {
        
        auxText = '';
        newItem = {};

        // END_DATETIME: moment.tz(this.state.END_DATE + ' ' + this.state.END_TIME,userTimezone).utc().format('YYYY-MM-DD HH:mm'),
        //data no presente
        console.dir(moment.tz(rows[i].BEGIN_DATETIME, timezone).utc().format('YYYY-MM-DD HH:mm') );
        console.dir(moment.utc().format('YYYY-MM-DD HH:mm'));

        if(moment.tz(rows[i].BEGIN_DATETIME, timezone).utc().format('YYYY-MM-DD HH:mm') < moment.utc().format('YYYY-MM-DD HH:mm')){
            auxText = auxText + " Data de início no passado; \n";
        }

        if(moment(rows[i].BEGIN_DATETIME, 'YYYY-MM-DD HH:mm') >= moment(rows[i].END_DATETIME, 'YYYY-MM-DD HH:mm')){
            auxText = auxText + " Data de início superior à data de fim; \n";
        }

        auxLengthRaw = rows[i].BEGIN_DATETIME.length;
        auxLengthTrim = rows[i].BEGIN_DATETIME.replace(/\s+/g, '').length;
        if(auxLengthTrim !== 15 || auxLengthRaw !== 16){
            auxText = auxText + " Data de início não está no formato correto (verifique espaços, se a hora tem 2 algarismos, por exemplo 01 em vez de 1); \n";
        }

        auxLengthRaw = rows[i].END_DATETIME.length;
        auxLengthTrim = rows[i].END_DATETIME.replace(/\s+/g, '').length;
        if(auxLengthTrim !== 15 || auxLengthRaw !== 16){
            auxText = auxText + " Data de fim não está no formato correto (verifique espaços, se a hora tem 2 algarismos, por exemplo 01 em vez de 1); \n";
        }

        if((rows[i].FLAG_G === 1 || rows[i].FLAG_GT === 1 || rows[i].FLAG_GC === 1) && (rows[i].FLAG_B === 1 || rows[i].FLAG_BT === 1 || rows[i].FLAG_BC === 1)){
            if(rows[i].REASON_PTG_PUMP === 'Não aplicável'){
                auxText = auxText + " Informação pública (Modo Bomba) tem de ter um valor válido; \n";
            }
        }

        if(rows[i].INFO_COM_SENS){
            auxLengthRaw = rows[i].INFO_COM_SENS.length;
            if(auxLengthRaw > 150){
                auxText = auxText + " Informação Comercialmente Sensível não pode possuir mais que 150 caracteres; \n";
            }
        }

        if(rows[i].COMMENTS){
            auxLengthRaw = rows[i].COMMENTS.length;
            if(auxLengthRaw > 150){
                auxText = auxText + " Comentários REN não pode possuir mais que 150 caracteres; \n";
            }
        }
        

        if(auxText !== ''){
            auxText = "Erro linha" + (i+1) + ': ' + auxText;
            newItem['MESSAGE'] = auxText;
            arrayMain.push(newItem);
        }
    }
    return arrayMain;
}


//Função para criar Notificações
export function notifyMe(title, text, url) {
    // Let's check if the browser supports notifications
    if (!("Notification" in window)) {
      alert("This browser does not support desktop notification");
    }
  
    // Let's check if the user is okay to get some notification
    else if (Notification.permission === "granted") {
        // If it's okay let's create a notification
        var options = {
            body: text,
            icon: "/logoedp.png",
            requireInteraction: true
            
        };
        // eslint-disable-next-line
        var notification = new Notification(title,options);
        notification.onclick = function(event) {
            event.preventDefault(); // prevent the browser from focusing the Notification's tab
            window.focus();
            this.close();
        }
    
    }
  
    // Otherwise, we need to ask the user for permission
    // Note, Chrome does not implement the permission static property
    // So we have to check for NOT 'denied' instead of 'default'
    else if (Notification.permission !== 'denied') {
        Notification.requestPermission(function (permission) {
            // Whatever the user answers, we make sure we store the information
            if (!('permission' in Notification)) {
                Notification.permission = permission;
            }
    
            // If the user is okay, let's create a notification
            if (permission === "granted") {
                var options = {
                    body: text,
                    icon: "/logoedp.png",
                };
            // eslint-disable-next-line  
            var notification = new Notification(title,options);
            }
        });
    }
}

//Get the current QH of the current timestamp
export function getCurrentQuarterHourPeriod() {
    const now = moment().tz("Europe/Madrid"); // Get current time
    const hour = now.hour();
    const minute = now.minute();

    // Calculate the quarter-hour period (0 to 95)
    const quarterHourPeriod = hour * 4 + Math.floor(minute / 15) +1;

    return quarterHourPeriod;
}

export function getQuarterHoursFrom23(numberHours) {
  const result = [];
  const start = new Date();          // today (local TZ)
  start.setHours(23, 0, 0, 0);       // 23:00:00.000

  const STEP_MS = 15 * 60 * 1000;    // 15 minutes in ms
  const POINTS = numberHours;        // 96 quarter-hours. or 92 or 100

  for (let i = 0; i < POINTS; i++) {
    let d = new Date(start.getTime() + i * STEP_MS);
    let hh = String(d.getHours()).padStart(2, '0');
    let mm = String(d.getMinutes()).padStart(2, '0');

    if(numberHours === 92){
        if(i === 8 || i === 9 || i === 10 || i === 11){
            //jump these timeblocks
        }else{
            result.push(`${hh}:${mm}`);
        }
    }else if(numberHours === 100){
        if(i < 12){
            //normal process
            result.push(`${hh}:${mm}`);
        }else{
            //duplicate previous hour
            d = new Date(start.getTime() + (i-4) * STEP_MS);
            hh = String(d.getHours()).padStart(2, '0');
            mm = String(d.getMinutes()).padStart(2, '0');
            result.push(`${hh}:${mm}`);
        }
    }else{
        result.push(`${hh}:${mm}`);
    }

    
  }
  return result;
}


// WEBPACK FOOTER //
// ./src/utils/validate.js